"use client"

import styled from "@emotion/styled"
import { Box } from "@mui/material"
import { useIsDesktop } from "../common/bit/MediaQueries"
import CircleImageLinkItem from "./CircleImageLinkItem"

const StyledContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 12px;
`

interface TitleItem {
  title: string
}

interface CircleImageLinkListTableProps {
  titles: TitleItem[]
  itemsList: any[]
}

const CircleImageLinkListTable = ({
  titles,
  itemsList,
}: CircleImageLinkListTableProps) => {
  const isDesktop = useIsDesktop()
  if (titles.length < 3) titles.push({ title: "" }) // Add empty string to fill the gap

  return (
    <StyledContainer>
      {isDesktop && (
        <CircleImageLinkItem
          isTitle={true}
          titles={titles}
          itemKey="circle-image-title"
          columns={[]}
        />
      )}

      {itemsList?.map((item, index) => {
        const itemKey = `circle-image-link-${index}`
        return (
          <CircleImageLinkItem
            key={itemKey}
            itemKey={itemKey}
            icon={item.icon}
            columns={item.columns}
            button={item.button}
            mobileTitles={titles}
          />
        )
      })}
    </StyledContainer>
  )
}

export default CircleImageLinkListTable
